import React, { useEffect, useState } from 'react';

import ListenableBodyPart from './ListenableBodyPart';
import Waveform from './Waveform';
import { STETHOSCOPE } from 'FRONTEND/utils/constants';
import useSize from 'FRONTEND/utils/hooks/useSize';
import { PJAX_MAIN_CONTAINER_ID } from 'LEGACY/constants';

const Stethoscope = ({ medias }) => {
  const mediaStethoscope = {};
  if (medias) {
    Object.keys(medias).forEach(k => {
      mediaStethoscope[k.toUpperCase()] = medias[k];
    });
  }
  const [selectedListeningPoint, setSelectedListeningPoint] = useState(false);
  let showAllfile = false;

  const mainContainer = document.getElementById(PJAX_MAIN_CONTAINER_ID);
  const mainContainerWidth = useSize({ current: mainContainer });

  const listeningPointClicked = (pointClicked) => {
    // deselecting or selecting an empty point
    if (pointClicked === selectedListeningPoint || !mediaStethoscope[pointClicked]) {
      showAllfile = true;
      toggleFile();
      setSelectedListeningPoint(false);
    }
  };

  const toggleFile = () => {
    const selectedMedia = mediaStethoscope[`${selectedListeningPoint}_ID`];
    const filePreviewId = `#file-preview_id_${selectedMedia}`;

    if (selectedListeningPoint && selectedMedia) {
      const filePreview = document.querySelector(filePreviewId);
      if (filePreview) {
        const downloads = filePreview.closest('div.row').getElementsByClassName('file-preview');
        for (const download of downloads) {
          const parentFieldDiv = download.parentNode.parentNode;
          if (showAllfile) {
            parentFieldDiv.style.display = 'block';
          } else {
            parentFieldDiv.style.display = parentFieldDiv.querySelector(filePreviewId) ? 'block' : 'none';
          }
        }
      }
    }
  };

  useEffect(() => {
    toggleFile();
  }, [selectedListeningPoint]);

  const renderFooter = () => selectedListeningPoint && mediaStethoscope[selectedListeningPoint] && (
    <div className='stethoscopeMedia-footer'>
      <Waveform url={mediaStethoscope[selectedListeningPoint]} />
    </div>
  );

  return (
    <>
      <div className={`stethoscope${mainContainerWidth <= 800 ? 'stethoscope--small' : ''}`}>
        <div className={`bodyListeningPoint-container${mainContainerWidth <= 800 ? 'bodyListeningPoint-container--small' : ''}`}>
          <div className='bodyListeningPoint'>
            <ListenableBodyPart
              bodyPart={STETHOSCOPE.BODY_CHEST}
              currentSelectedPoint={selectedListeningPoint}
              medias={mediaStethoscope}
              setSelectedListeningPoint={setSelectedListeningPoint}
              listeningPointClicked={listeningPointClicked}
            />
          </div>
          <div className='bodyListeningPoint'>
            <ListenableBodyPart
              bodyPart={STETHOSCOPE.BODY_BACK}
              currentSelectedPoint={selectedListeningPoint}
              medias={mediaStethoscope}
              setSelectedListeningPoint={setSelectedListeningPoint}
              listeningPointClicked={listeningPointClicked}
            />
          </div>
          <div className='bodyListeningPoint'>
            <ListenableBodyPart
              bodyPart={STETHOSCOPE.BODY_ABDOMEN}
              currentSelectedPoint={selectedListeningPoint}
              medias={mediaStethoscope}
              setSelectedListeningPoint={setSelectedListeningPoint}
              listeningPointClicked={listeningPointClicked}
            />
          </div>
        </div>
        {mainContainerWidth <= 800 && renderFooter()}
      </div>
      {mainContainerWidth > 800 && renderFooter()}
    </>
  );
};

export default Stethoscope;
